import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import "./ErrorPage.css"
import { Button } from "@mui/material";
const ErrorPage = () => {
  const error: any = useRouteError();
  document.getElementById("body")!.style.backgroundColor = "#e5e8da"; 
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      {isRouteErrorResponse(error) && (
        <i>{error.statusText || error.statusText}</i>
      )}
      {!isRouteErrorResponse(error) && (
        <p>{error.message || "Unknown Error"}</p>
      )}
      <div className="button-back"><Button variant="contained" href="/home">Press here to go back to HomePage</Button></div>
    </div>
  );
};

export default ErrorPage;
